import React, { useEffect, useMemo } from 'react';
import { getTranslateByKey, isEmpty, isNullUndefined } from '@/main/services/utils';
import { FormControlLabel } from '@mui/material';

import KogCheckbox from '@/main/components/shared/checkbox/kogCheckbox';
import ResultNotFoundComponent from '@/main/components/shared/resultNotFound/resultNotFoundComponent';
import { QuoteNoSupplierAssignedItemResponse } from '@/main/models/response';
import { IMAGE_DEFAULT } from '@/main/services/constants';

import QuoteProcurementPartInfo from '@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo';
import SkeletonModalRequoteParts from '../skeletonModalRequoteParts';
import * as S from './styles';
import { usePartTypeReducer } from '@/main/store/partType';
import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';
import { useFormContext, useWatch } from 'react-hook-form';
import { IQuoteNoSupplierAssignedItemResponse, IRequoterequest, TypeSectionPart } from '../modalRequoteParts';
import KogCheckBoxControlled from '@/main/components/shared/checkbox/checkBoxControlled';


interface IAreaPartsSelectProps {
  type: TypeSectionPart;
  dataParts?: QuoteNoSupplierAssignedItemResponse[];
  isLoadingParts: boolean;
  numbersParts?: number;
  indexSupplier: number;
  showPartTypeControl: boolean; 
  handleToggleCheckbox: (guid: string | string[]) => void;
}
function AreaPartsSelectRequote({
  type,
  dataParts,
  isLoadingParts,
  numbersParts,
  indexSupplier,
  showPartTypeControl,
  handleToggleCheckbox = () => { }
}: IAreaPartsSelectProps) {

  const SHOW_DROPDOWN_PART_TYPE = showPartTypeControl;
  const { partType: partTypeReducer } = usePartTypeReducer();
  const {
    control,
    setValue,
    watch
  } = useFormContext<IRequoterequest>();
  const watcherFields = useWatch({
    control,
    name: `parts.${indexSupplier}.items`
  });
  const controlledFields =
    isNullUndefined(watcherFields) ? [] :
      watcherFields
        .filter(item => item.sectionPart === type)
        .map((field,) => {
          return {
            ...field
          };
        });

  const allCheckboxesSelected = useMemo(() => {
    if (isNullUndefined(controlledFields)) return false;

    return controlledFields.every(item => item.isSelected);
  }, [JSON.stringify(controlledFields)])

  function handleToggleCheckboxAll() {
    if (isNullUndefined(dataParts)) return;
    const isAllCheckboxesSelected = controlledFields.every(item => item.isSelected);
    controlledFields.forEach((item, index) => {
      setValue(`parts.${indexSupplier}.items.${index}.isSelected`, !isAllCheckboxesSelected);
    });
  }

  if (isLoadingParts) return <>{Array.from(new Array(numbersParts)).map((_, index) => <SkeletonModalRequoteParts key={index} />)}</>
  if (isNullUndefined(dataParts)) return <ResultNotFoundComponent />
  if (isEmpty(dataParts)) return <></>

  type keyFieldsItems = keyof IQuoteNoSupplierAssignedItemResponse;
  const nameField = (name: keyFieldsItems, index: number) => `parts.${indexSupplier}.items.${index}.${name}`;

  const keyTranslatePartSelect = type === 'abovePrive' ? 'information.partsAbovePriceCap' : 'information.partsWithNoAnswer';
  const titlePartsSelect = getTranslateByKey(keyTranslatePartSelect);
  const isDisabledPartTypeDrop = isNullUndefined(partTypeReducer.data) || partTypeReducer.data.length === 1;

  return (
    <S.Container>
      <S.Headerpart>
        <S.HeaderTitle>{titlePartsSelect}</S.HeaderTitle>
        <S.AreaSelectAll>
          <FormControlLabel
            label={getTranslateByKey('information.selectAll')}
            labelPlacement='start'
            control={
              <KogCheckbox
                id={`id-createOrder-checkbox-selectAçç-${type}`}
                checked={allCheckboxesSelected}
                value={allCheckboxesSelected}
                onChange={() => handleToggleCheckboxAll()}
              />}
          />
        </S.AreaSelectAll>
      </S.Headerpart>
      {controlledFields.map((item, index) => (
        <S.RowPart key={item.guidQuoteItem} >
          <S.ImagePart src={IMAGE_DEFAULT} />
          <S.AreaTitlePart>
            <QuoteProcurementPartInfo
              data={item.quoteProcurementPartInfo}
              renderType="column"
            />
            {SHOW_DROPDOWN_PART_TYPE && (
              <KogAutoCompleteControlled
                id="id-createOrder-select-partType"
                nameCustom={nameField("partType", index)}
                isDefaultValueUnique
                valueDefaultKey={item.idPartType}
                setValueCustom={setValue}
                label=''
                placeholder={getTranslateByKey('information.partTypes')}
                control={control}
                rulesCustom={{ required: false }}
                options={partTypeReducer.data}
                isLoading={partTypeReducer.isLoading}
                disabled={isDisabledPartTypeDrop}
                onChangeCustom={() => { }}
              />
            )}

          </S.AreaTitlePart>

          <KogCheckBoxControlled
            id={`id-createOrder-checkbox-select-${type}-${item.guidQuoteItem}`}
            nameCustom={nameField("isSelected", index)}
            control={control}
            label=''
          />
        </S.RowPart>
      ))}
    </S.Container>
  )
}

export default AreaPartsSelectRequote